module.exports = __webpack_public_path__ + "img/floodlight_power.fdc06a74.png";